import { Table as BaseTable, TableProps } from '@/components/table'
import { Query } from './table_query'
import { NotificationsQuery } from './__generated__/table_query'
import { useQuery } from '@apollo/client'
import { Inline as Error } from '@/components/error'
import { Inline as Loading } from '@/components/loading'
import { useContext } from 'react'
import { format } from 'date-fns'
import { EventFilters } from '@/types'
import { CurrentTenantContext } from '@/core/current_tenant_context'
import { useTable } from '@/helpers/useTable'
import { dedupe } from '@/helpers/dedupe'
import { ShowDialog } from './show_dialog'

export const Table = ({ title, pageSize = 10, onIndex = false }: TableProps) => {
  const { currentCompany } = useContext(CurrentTenantContext)
  const { data, loading, error, refetch, fetchMore } = useQuery<NotificationsQuery>(
    Query,
    { variables: { companyId: currentCompany?.id, first: pageSize } }
  )
  const { pageInfo, openShow, showShow, hideShow, resourceId } = useTable({ pageInfo: data?.currentUser.notifications.pageInfo, onIndex, basePath: '/inbox' })

  if (error) return <Error message={error.message} />
  if (loading || !data) return <Loading />

  return (
    <>
      <BaseTable<EventFilters>
        headings={[{ name: 'Title' }, { name: 'Message' }, { name: 'Posted' }]}
        moreToFetch={pageInfo.current?.hasNextPage}
        refetch={refetch}
        title={title}
        fetchMore={() => fetchMore({
          variables: { after: pageInfo.current?.endCursor },
          updateQuery(previousData, { fetchMoreResult }) {
            if (Object.keys(previousData).length === 0) return fetchMoreResult
            fetchMoreResult.currentUser.notifications.nodes = dedupe([
              ...previousData.currentUser.notifications.nodes,
              ...fetchMoreResult.currentUser.notifications.nodes
            ])
            return { ...fetchMoreResult }
          }
        })}
        filters={[
          {
            index: 0,
            setValue: (set, value) => set(f => ({ ...f, titleCont: value })),
            type: 'text',
            placeholder: 'What was it for?'
          },
          {
            index: 1,
            setValue: (set, value) => set(f => ({ ...f, messageCont: value })),
            type: 'text',
            placeholder: 'What was it about?'
          },
        ]}
        rows={data.currentUser.notifications.nodes.map(notification => (
          {
            id: notification.id,
            columns: [
              notification.title,
              notification.message,
              format(notification.postedAt, 'KK:mm dd/MM/yyyy'),
            ]
          }
        ))}
        onRowClick={showShow}
      />
      { resourceId && <ShowDialog id={resourceId} open={openShow} setOpen={hideShow} /> }
    </>
  )
}
